"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M8.88281 5.91406V9.71484C8.74154 9.90169 8.52051 10.1068 8.21973 10.3301C7.9235 10.5488 7.5293 10.738 7.03711 10.8975C6.54492 11.057 5.93197 11.1367 5.19824 11.1367C4.57389 11.1367 4.00195 11.0319 3.48242 10.8223C2.96289 10.6081 2.514 10.2959 2.13574 9.88574C1.76204 9.47559 1.47266 8.97656 1.26758 8.38867C1.0625 7.79622 0.959961 7.12174 0.959961 6.36523V5.6748C0.959961 4.92285 1.05339 4.25293 1.24023 3.66504C1.43164 3.07259 1.70508 2.57129 2.06055 2.16113C2.41602 1.75098 2.8444 1.44108 3.3457 1.23145C3.85156 1.01725 4.4235 0.910156 5.06152 0.910156C5.87728 0.910156 6.55176 1.04688 7.08496 1.32031C7.62272 1.58919 8.03743 1.96289 8.3291 2.44141C8.62077 2.91992 8.80534 3.4668 8.88281 4.08203H7.20117C7.14648 3.73568 7.03939 3.42578 6.87988 3.15234C6.72493 2.87891 6.50163 2.66471 6.20996 2.50977C5.92285 2.35026 5.54915 2.27051 5.08887 2.27051C4.69238 2.27051 4.34375 2.3457 4.04297 2.49609C3.74219 2.64648 3.49154 2.86751 3.29102 3.15918C3.09505 3.45085 2.94694 3.80632 2.84668 4.22559C2.74642 4.64486 2.69629 5.12337 2.69629 5.66113V6.36523C2.69629 6.91211 2.75326 7.39746 2.86719 7.82129C2.98568 8.24512 3.1543 8.60286 3.37305 8.89453C3.59635 9.1862 3.86751 9.40723 4.18652 9.55762C4.50553 9.70345 4.86556 9.77637 5.2666 9.77637C5.65853 9.77637 5.97982 9.74447 6.23047 9.68066C6.48112 9.6123 6.67936 9.53255 6.8252 9.44141C6.97559 9.3457 7.0918 9.25456 7.17383 9.16797V7.19238H5.10254V5.91406H8.88281Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;